/* SILK supplemental interactions. No tag loader, config call, page views or ecommerce duplication.
 * Requires the existing Google integration to expose window.gtag and Shopify Customer Privacy.
 * Fail closed while either dependency is unavailable; never replay pre-consent interactions.
 */
(function () {
  'use strict';
  if (window.__silkInteractionsInstalled) return;
  window.__silkInteractionsInstalled = true;
  var MID = 'G-SBDK11RFS2';
  var routes = /^\/(?:$|products\/[a-z0-9-]+\/?$|collections\/[a-z0-9-]+\/?$|pages\/[a-z0-9-]+\/?$|cart\/?$)/i;
  function path(value) {
    try { var u = new URL(value, location.origin); return u.origin === location.origin && routes.test(u.pathname) ? u.pathname : null; }
    catch (_) { return null; }
  }
  function allowed() {
    try { return typeof window.gtag === 'function' && window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function zone(el) {
    if (el.closest('header, .header, #header')) return 'header';
    if (el.closest('footer, .footer, #footer')) return 'footer';
    if (el.closest('nav')) return 'navigation';
    return 'content';
  }
  function send(name, parameters) {
    if (!allowed()) return;
    var page = path(location.href);
    if (!page) return; // No account/checkout/search URLs or tokens in custom events.
    try { window.gtag('event', name, Object.assign({send_to:MID,page_location:location.origin+page,page_path:page}, parameters)); }
    catch (_) { /* Measurement must never interrupt shopping. */ }
  }
  document.addEventListener('click', function (event) {
    if (!event.isTrusted || !allowed()) return;
    var target = event.target && event.target.closest && event.target.closest('a, button');
    if (!target || target.closest('form') || target.disabled) return;
    var href = target.getAttribute('href') || '';
    if (/^mailto:/i.test(href)) return send('contact_click',{contact_method:'email',link_area:zone(target)});
    if (/^tel:/i.test(href)) return send('contact_click',{contact_method:'phone',link_area:zone(target)});
    if (/^https:\/\/(?:wa\.me|api\.whatsapp\.com)\//i.test(href)) return send('contact_click',{contact_method:'whatsapp',link_area:zone(target)});
    if (!href) return;
    var dest = path(href);
    if (!dest) return;
    send('internal_link_click',{destination_path:dest,link_area:zone(target),destination_type:dest.indexOf('/products/')===0?'product':dest.indexOf('/collections/')===0?'collection':dest==='/cart'?'cart':'page'});
  }, true);
  document.addEventListener('change', function (event) {
    if (!event.isTrusted || !allowed() || !/^\/products\//.test(location.pathname)) return;
    var el=event.target;
    if (!el || !el.matches('input[type="radio"], select')) return;
    // Only known packaging sizes. Never forward arbitrary input text or form values.
    var size = String(el.value || '').trim().match(/^(250|500)\s*ml$/i);
    if (size) send('size_select',{size_ml:Number(size[1])});
  },true);
  document.addEventListener('toggle',function(event){
    var el=event.target;
    if (!el || el.tagName!=='DETAILS' || !el.open || !el.closest('main, #main-content')) return;
    // Index only; no text extraction that could capture personal content.
    var all=Array.from(document.querySelectorAll('main details, #main-content details'));
    var index=all.indexOf(el);
    if(index>=0) send('detail_open',{detail_index:index+1});
  },true);
})();
